import i18n from 'modules/core/lib/i18n'

export const defaultOffsetDirection = () => [
  { value: 'after', label: i18n.t('processes.process_settings.tasks.form.due_dates.after') },
  { value: 'before', label: i18n.t('processes.process_settings.tasks.form.due_dates.before') },
]
